import { legacyLogOut } from '../util/utils'

// Returns boolean indicating presence of user token in storage
export default (state = null, { type, payload }) => {
  switch (type) {
    case 'CREATE_SESSION':
      return payload
    case 'CLEAR_SESSION':
      legacyLogOut()
      return null
    default:
      return state
  }
}
